import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { VerticalBarWidget } from './vertical_bar_widget';

export interface Props extends WithTranslation {
  height: number
  width: number
  legend?: boolean
  onPointClick?: (item: any) => void
  params?: string
}

export function EOLCategoryChart({ height, legend, width, onPointClick, params, t, i18n: { language } }: Props) {
  return (
    <VerticalBarWidget
      title={t('charts.end_of_lease_assets')}
      url={`/assets/eol_category_chart?${params}&language=${language}`}
      legend={legend}
      width={width}
      height={height}
      onPointClick={onPointClick}
    />
  );
}

export default withTranslation()(EOLCategoryChart)